document.addEventListener("DOMContentLoaded", function () {

    const exePersons = document.querySelectorAll(".exe-person"),
          exeModal = document.getElementById("exe-modal"),
          exeModalContent = document.getElementById("exe-modal__content"),
          exeClose = document.getElementById("exe-modal__close");
    var   dialogSupported = true;

    if (typeof HTMLDialogElement != 'function') {
      dialogSupported = false;
      exeModal.classList.add('no-dialog-support');
      showModal = function() {
        exeModal.classList.add('no-support-open');
      };
      close = function() {
        exeModal.classList.remove('no-support-open');
      };
    }

    exePersons.forEach(function (element) {
      element.addEventListener("click", function(e) {
        e.preventDefault();
        const bioData = element.getAttribute("data-bio"),
              bioImg = element.getAttribute("data-img");

  
        if (bioData) {
          exeModalContent.innerHTML = '<img src="'+bioImg+'" id="exe-modal__img">'+ bioData;
          if(dialogSupported){
            exeModal.showModal();
          } else {
            showModal();
          }
          document.body.classList.add('noscroll');
          exeModalContent.scrollTo(0, 0);
          exeClose.focus();
        }
      });
    });


    exeModal.addEventListener("click", function(e) {
        e.preventDefault();
        if (e.target === exeModal || e.target === exeClose) {
          if(dialogSupported){
            exeModal.close();
          } else {
            close();
          }
          document.body.classList.remove('noscroll');
        }
      });

      document.onkeydown = function(e) {
        if(e.key === "Escape"){
          document.body.classList.remove('noscroll');
        }
      }
  });